import Component from './OperatorLastActive.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconOperatorLastActive', Component);
  },
};
